(() => {
  if (window.BlazeXMobileNavReady) return;
  window.BlazeXMobileNavReady = true;

  const drawer = document.getElementById('t4s-menu-drawer');
  if (!drawer) return;

  const sourceIds = ['shopify-section-top-bar', 'shopify-section-header-inline'];

  const getShell = () => {
    let shell = drawer.querySelector('[data-bx-mobile-nav-shell]');
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'bx-mobile-nav__section-shell';
      shell.dataset.bxMobileNavShell = '';
      shell.hidden = true;
      drawer.prepend(shell);
    }
    return shell;
  };

  const buildHeader = (shell) => {
    if (shell.childElementCount) return;

    sourceIds.forEach((sourceId) => {
      const source = document.getElementById(sourceId);
      if (!source) return;

      const clone = source.cloneNode(true);
      clone.removeAttribute('id');
      clone.dataset.bxMobileNavSection = sourceId;
      clone.querySelectorAll('script').forEach((script) => script.remove());
      clone.querySelectorAll('[id]').forEach((element) => {
        element.removeAttribute('id');
      });
      shell.appendChild(clone);
    });

    shell.hidden = shell.childElementCount === 0;
  };

  const syncState = () => {
    const isOpen = drawer.getAttribute('aria-hidden') === 'false';
    document.documentElement.classList.toggle('bx-mobile-nav-open', isOpen);
    document.querySelectorAll('.t4s-push-menu-btn').forEach((button) => {
      const menuIcon = button.querySelector('.bx-mobile-menu-icon');
      const closeIcon = button.querySelector('.bx-mobile-menu-close-icon');
      menuIcon?.style.setProperty('display', isOpen ? 'none' : 'block', 'important');
      closeIcon?.style.setProperty('display', isOpen ? 'block' : 'none', 'important');
    });
    if (isOpen) buildHeader(getShell());
  };

  new MutationObserver(syncState).observe(drawer, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    childList: true
  });

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('.t4s-push-menu-btn');
    if (!closeButton || !document.documentElement.classList.contains('bx-mobile-nav-open')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (window.T4SThemeSP?.Drawer?.close) {
      window.T4SThemeSP.Drawer.close(event);
      return;
    }

    document.querySelector('[data-drawer-close]')?.click();
  }, true);

  syncState();
})();
